module.exports = __webpack_public_path__ + "img/sceneImg-mob.db593da8.jpg";